// Node imports
import { ButtonBase, dispatcher } from "@quest/base-core";
import { ButtonController, Model, SlotConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";
import { SlotConstants } from "@quest/slot-core/dist/SlotConstants/SlotConstants";

// Class imports
import { eventDispatchers } from "../Constants/EventDispatchers";
import { BaseGameViewGame } from "./BaseGameViewGame";
import { gameConstants } from "../Constants/gameConstants";
import { SlotEventConstants } from "@quest/slot-core/dist/SlotConstants/SlotEventDispatchers";

/**
 * ButtonControllerGame class handles the  console panelo of the base game and its buttons.
 */
export class ButtonControllerGame extends ButtonController {
  constructor(view: BaseGameViewGame, model: Model) {
    super(view, model)
    this.handleButtonPanelBGAlpha();
  }
  // Override to reset progress bar
  protected onChangeStake(value: number): void {
    super.onChangeStake(value);
    dispatcher.fireEvent(eventDispatchers.RESET_PROGRESS_BAR_ELEMENTS);
    dispatcher.fireEvent(eventDispatchers.UPDATE_JACKPOT_METERS_VALUES);
  }
  /**
   * temporarily created as image does not have alpha support from json
   * add alpha support in Basegameview to avoid this implementation
   */
  private handleButtonPanelBGAlpha(): void {
    this.view.getImageById("Button_Panel_Base") && (this.view.getImageById("Button_Panel_Base").alpha = gameConstants.BUTTON_PANEL_BG_ALPHA)
    this.view.getImageById("portraitButtonBG") && (this.view.getImageById("portraitButtonBG").alpha = gameConstants.BUTTON_PANEL_BG_ALPHA)
    this.view.getImageById("Button_Panel_BasePort") && (this.view.getImageById("Button_Panel_BasePort").alpha = gameConstants.BUTTON_PANEL_BG_ALPHA)
  }
  // Override to hide autoplaybtn in mobile and desktop both
  protected hideAutoplayOnBtn() {
    this.view.getButtonById(SlotConstants.AutoPlayBtnId).visible = false;
  }
  /**
   * to suspend presentation on pressup
   */
  protected onturboBtnOnPressUp(): void {
    super.onturboBtnOnPressUp();
    dispatcher.fireEvent(SlotEventConstants.SUSPEND_WINPRESENTATION);
  }
  protected onturboBtnOffPressUp(): void {
    super.onturboBtnOffPressUp();
    this.suspendWinWhenButtonPressed();
    dispatcher.fireEvent(SlotEventConstants.SUSPEND_WINPRESENTATION);
  }
  protected onDisabledAllButtons(evt: any) {
    let btnId;
    for (btnId in this.view.getbuttonArray()) {
      if (SlotConstantsBehavior.SOUND_BUTTONS.indexOf(btnId) === -1) {
        if (btnId != "autoPlayOff") {
          (this.view.getbuttonArray()[btnId] as ButtonBase).disableAndTint();
        }
      }
    }
    if (this.turboBtnOn.visible) {
      this.turboBtnOn.disableAndTint();
    }
    else {
      this.turboBtnOff.disableAndTint();
    }
  }
}
